import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../../../config/config";
import "../../../../css/AddTag.css";

export default function AddTag() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    slug: "",
  });
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [csrfToken, setCsrfToken] = useState("");

  useEffect(() => {
    // دریافت CSRF Token
    fetch(`${BASE_URL}/csrf-token`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => setCsrfToken(data.csrfToken))
      .catch(console.error);
  }, []);

  const generateSlug = (text) => {
    if (!text) return "";
    return text
      .replace(/[\s]+/g, "_")
      .replace(/[^\u0600-\u06FFa-zA-Z0-9_]/g, "")
      .replace(/_+/g, "_")
      .replace(/^_+|_+$/g, "");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "name" ? { slug: generateSlug(value) } : {}),
    }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    // اعتبارسنجی
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "نام برچسب الزامی است";
    if (!formData.slug.trim()) newErrors.slug = "Slug الزامی است";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsLoading(false);
      return;
    }

    try {
      const res = await fetch(`${BASE_URL}/blog/tags`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "CSRF-Token": csrfToken,
        },
        credentials: "include",
        body: JSON.stringify(formData),
      });

      const result = await res.json();

      if (!res.ok) {
        if (result.errors) setErrors(result.errors);
        setMessage(result.message || "خطا در ثبت برچسب");
        return;
      }

      setMessage("برچسب با موفقیت ثبت شد");
      setFormData({ name: "", slug: "" });
      setTimeout(() => navigate("/admin/blog/tags"), 1500);
    } catch (err) {
      setMessage("خطا در برقراری ارتباط با سرور");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="tag-form-container">
      <h2>افزودن برچسب جدید</h2>

      {message && (
        <div
          className={`alert ${message.includes("موفق") ? "success" : "error"}`}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>
            نام برچسب <span className="required">*</span>
          </label>
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            className={errors.name ? "error" : ""}
          />
          {errors.name && <span className="error-text">{errors.name}</span>}
        </div>

        <div className="form-group">
          <label>
            Slug (لینک یکتا) <span className="required">*</span>
          </label>
          <input
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className={errors.slug ? "error" : ""}
          />
          {errors.slug && <span className="error-text">{errors.slug}</span>}
        </div>

        <div className="form-actions">
          <button type="submit" disabled={isLoading} className="btn-submit">
            {isLoading ? "در حال ذخیره..." : "ذخیره برچسب"}
          </button>
          <button
            type="button"
            onClick={() => navigate("/admin/blog/tags")}
            className="btn-cancel"
          >
            انصراف
          </button>
        </div>
      </form>
    </div>
  );
}